
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { defaultRevalidationInterval } from '@helpers/fallback';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import useCmsPage, { endpoint } from '@hooks/useCmsPage';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';
import Page from '@organisms/Page/Page';
import React from 'react';
import { unstable_serialize } from 'swr';
import productPageTemplate from './productPageTemplate';
import { getSlotsForPage } from '@helpers/cmsTemplateHelper';
import type { PageAdaptedData } from '@occ/api-client';
import type { PageWithSlots } from '@api/interfaces/pageApi';
const ProductPage = ({ code }: InferGetStaticPropsType<typeof getStaticProps>) => {
    const { cmsPage, error, isLoading } = useCmsPage(undefined, 'ProductPage', code as string);
    if (!isLoading && error)
        return <ErrorComponent errorCode={404}/>;
    return <Page cmsPage={cmsPage}/>;
};
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}
async function getStaticProps({ params }: GetStaticPropsContext) {
    const name = params?.name as string;
    const code = name?.split('-').at(-1);
    console.info('Using cached product page template for product:', code);
    const filteredSlots = getSlotsForPage(productPageTemplate);
    const { ...partialData } = productPageTemplate as Partial<PageAdaptedData>;
    delete partialData.contentSlots;
    const cmsPage = {
        ...partialData,
        breadcrumbs: productPageTemplate.breadcrumbs,
        slots: filteredSlots,
    } as PageWithSlots;
    return {
        props: {
            // populate swr fallback
            fallback: {
                [unstable_serialize({
                    endpoint,
                    pageType: 'ProductPage',
                    code,
                })]: cmsPage,
            },
            code,
            pageType: 'ProductPage',
        },
        revalidate: defaultRevalidationInterval,
    };
}
export default ProductPage;

    async function __Next_Translate__getStaticProps__197a5ece6f2__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/produktdetalj/ProductPage.tsx',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197a5ece6f2__ as getStaticProps }
  